export interface RetiredAppInfo {
    hostName: string;
    /** Minimum host version that supports the new assistant, if known. */
    minVersion?: string;
    releaseNotesUrl?: string;
    /** Overrides the default "View release notes" button label. */
    linkLabel?: string;
}

const HOST_RELEASE_INFO: Array<{
    match: string;
    displayName: string;
    minVersion?: string;
    releaseNotesUrl: string;
    linkLabel?: string;
}> = [
        {
            match: "novapoint",
            displayName: "Novapoint",
            minVersion: "2026.3",
            releaseNotesUrl: "https://help.trimble.com/doc/novapoint/novapoint/whats-new",
        },
        {
            match: "quadri",
            displayName: "Quadri",
            minVersion: "2026.3",
            releaseNotesUrl:
                "https://help.trimble.com/doc/quadri/quadri/quadri-for-windows/view/civil-design-assistant-for-quadri",
            linkLabel: "Read more",
        },
        {
            match: "tcom",
            displayName: "Trimble Connect Object Manager",
            releaseNotesUrl:
                "https://networkcommunity.trimble.com/product-updates?filters%5BproductArea%5D%5B0%5D=64",
        },
    ];

export function resolveRetiredAppInfo(hostName?: string): RetiredAppInfo {
    const name = hostName?.trim() ?? "";
    const lower = name.toLowerCase();
    const entry = HOST_RELEASE_INFO.find((e) => lower.includes(e.match));
    return {
        hostName: entry?.displayName ?? (name || "the host application"),
        minVersion: entry?.minVersion,
        releaseNotesUrl: entry?.releaseNotesUrl,
        linkLabel: entry?.linkLabel,
    };
}
